import CryptoJS from 'crypto-js'

const cryptoEdsKeys = {
  computed: {
    secretKey() {
      return this.$User.id + '_SECRET'
    }
  },
  methods: {
    encryptKeyInfo(dataToEncrypt, secret = this.secretKey) {
      return CryptoJS.AES.encrypt(dataToEncrypt, secret).toString()
    },
    decryptKeyInfo(dataToDecrypt, secret = this.secretKey) {
      const decryptedBytes = CryptoJS.AES.decrypt(dataToDecrypt, secret)
      const decryptedJsonString = decryptedBytes.toString(CryptoJS.enc.Utf8)
      return JSON.parse(decryptedJsonString)
    }
  }
}

export default cryptoEdsKeys
